/*
 * brand.js - Sets the title and colours to use
 */
'use strict';

Sao.config.title = 'Evinox';
Sao.config.icon_colors = '#ed8719,#777,#d9534f'.split(',');
